import { useState, useEffect } from "react";
import { updateVendor, getVendorById } from "../Api/MerchantMaster";
import {
  getAllCountries,
  getCitiesByTehsil
} from "../Api/CustomerMaster";
import { Form, Button, Row, Col, Container, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
import "../Styling/vendormaster.css";
import { useNavigate, useParams } from "react-router-dom";

const EditVendor = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { vendorCode } = useParams();

  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [vendorData, setVendorData] = useState({
    vendorName: "",
    Short_Names: "",
    countryCode: "",
    mobileCountrycode: "",
    mobileNumber: "",
    Address1: "",
    Address2: "",
    Address3: "",
    Pincode: ""
  });

  const [dropdownData, setDropdownData] = useState({
    countries: [],
    cities: []
  });

  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
  const userId = userDetails?.userId;
  const organisationId = userDetails?.organisationId || user?.organisationId;

  // Missing handleChange function - ADD THIS
  const handleChange = (e) => {
    const { name, value } = e.target;
    setVendorData(prev => ({ 
      ...prev, 
      [name]: value 
    }));

    // If country changes, reload cities
    if (name === "countryCode" && value) {
      loadCities(value);
    }
  };

  const loadCities = async (countryCode) => {
    try {
      const cities = await getCitiesByTehsil(countryCode);
      setDropdownData(prev => ({ ...prev, cities }));
    } catch (error) {
      console.error("Error loading cities:", error);
    }
  };

  // Load vendor data and dropdowns when component mounts
  useEffect(() => {
    const loadData = async () => {
    //   if (!vendorCode) {
    //     toast.error("Vendor Code not found");
    //     navigate('/vendors/list');
    //     return;
    //   }

      setInitialLoading(true);
      try {
        // Load dropdown data first
        // const countries = await getAllCountries();
        // setDropdownData(prev => ({ ...prev, countries }));

        // Load vendor data using vendorCode
        const vendor = await getVendorById(vendorCode);
        
        // if (!vendor) {
        //   toast.error("Vendor not found");
        //   navigate('/vendors/list');
        //   return;
        // }

        console.log("Loaded vendor data:", vendor);

        // Map vendor data to form state - CORRECTED FIELD MAPPING
        setVendorData({
          vendorName: vendor.name || vendor.vendorName || "",
          Short_Names: vendor.shortNames || vendor.Short_Names || "",
          countryCode: vendor.countryCode || vendor.Country_Code || "",
          mobileCountrycode: vendor.mobileCountrycode || vendor.mobile_countrycode || "",
          mobileNumber: vendor.mobileNumber || vendor.mobile_number || "",
          Address1: vendor.address1 || vendor.Address1 || "",
          Address2: vendor.address2 || vendor.Address2 || "",
          Address3: vendor.address3 || vendor.Address3 || "",
          Pincode: vendor.pincode || vendor.Pincode || ""
        });

        // Load cities if country code exists
        // if (vendor.countryCode || vendor.Country_Code) {
        //   await loadCities(vendor.countryCode || vendor.Country_Code);
        // }

      } catch (error) {
        // console.error("Error loading vendor:", error);
        // toast.error(`Error loading vendor data: ${error?.message || error}`);
        // navigate('/vendors/list');
      } finally {
        setInitialLoading(false);
      }
    };

    loadData();
  }, [vendorCode, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!vendorCode) {
      toast.error("Vendor Code not found");
      return;
    }

    // Enhanced validation
    if (!vendorData.vendorName.trim()) {
      toast.error("Vendor Name is required");
      return;
    }

    if (!vendorData.countryCode) {
      toast.error("Country is required");
      return;
    }

    setLoading(true);
    try {
      // CORRECTED: Use proper field names that match your DTO
      const requestData = {
        Name: vendorData.vendorName.trim(),
        Short_Names: vendorData.Short_Names.trim(),
        Country_Code: vendorData.countryCode,
        mobile_countrycode: vendorData.mobileCountrycode,
        mobile_number: vendorData.mobileNumber,
        Address1: vendorData.Address1,
        Address2: vendorData.Address2,
        Address3: vendorData.Address3,
        Pincode: vendorData.Pincode,
        Organisation_Id: parseInt(organisationId),
        // Add default values for required fields
        Active: "Yes",
        Currency: "INR",
        Type: "supplier"
      };

      console.log("Updating vendor with code:", vendorCode);
      console.log("Request data:", requestData);
      console.log("User ID:", userId);

      // Make sure userId is passed correctly to the API
      const result = await updateVendor(vendorCode, requestData, userId);
      
      if (result) {
        toast.success("Vendor updated successfully!");
        setTimeout(() => {
          navigate('/vendors/list');
        }, 1500);
      } else {
        throw new Error("No response from server");
      }

    } catch (err) {
      console.error("Update error:", err);
      toast.error(`Error updating vendor: ${err?.message || err}`);
    } finally {
      setLoading(false);
    }
  };

  if (initialLoading) {
    return (
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <div className="loading-overlay">
            <Sample14 />
            <p>Loading vendor data...</p>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="fields-title">Edit Vendor</h2>
            {/* CORRECTED: Display vendorCode instead of vendorId */}
            <p className="text-muted">Vendor Code: {vendorCode}</p>
          </div>
          <Button 
            variant="outline-secondary" 
            onClick={() => navigate('/vendors/list')}
          >
            Back to List
          </Button>
        </div>

        <Card>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Vendor Name <span className="text-danger">*</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="vendorName" 
                      value={vendorData.vendorName} 
                      onChange={handleChange} 
                      required 
                      placeholder="Enter vendor name"
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Short Name</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="Short_Names" 
                      value={vendorData.Short_Names} 
                      onChange={handleChange} 
                      placeholder="Enter short name"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                {/* <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Country Code <span className="text-danger">*</span></Form.Label>
                    <Form.Select 
                      name="countryCode" 
                      value={vendorData.countryCode} 
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Country</option>
                      {dropdownData.countries.map((country) => (
                        <option key={country.code} value={country.code}>
                          {country.name} ({country.code})
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col> */}
{/*                 
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>City</Form.Label>
                    <Form.Select 
                      name="cityCode" 
                      value={vendorData.cityCode} 
                      onChange={handleChange}
                    >
                      <option value="">Select City</option>
                      {dropdownData.cities.map((city) => (
                        <option key={city.code} value={city.code}>
                          {city.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col> */}
              </Row>

              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Country Code</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="mobileCountrycode" 
                      value={vendorData.mobileCountrycode} 
                      onChange={handleChange} 
                      placeholder="+91"
                      maxLength={5}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control 
                      type="tel" 
                      name="mobileNumber" 
                      value={vendorData.mobileNumber} 
                      onChange={handleChange} 
                      placeholder="10-digit mobile number"
                      pattern="[0-9]{10}"
                      maxLength={10}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Pincode</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="Pincode" 
                      value={vendorData.Pincode} 
                      onChange={handleChange} 
                      placeholder="Enter pincode"
                      maxLength={10}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 1</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="Address1" 
                      value={vendorData.Address1} 
                      onChange={handleChange} 
                      placeholder="Address line 1"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 2</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="Address2" 
                      value={vendorData.Address2} 
                      onChange={handleChange} 
                      placeholder="Address line 2"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 3</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="Address3" 
                      value={vendorData.Address3} 
                      onChange={handleChange} 
                      placeholder="Address line 3"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex gap-2 mt-4">
                <Button 
                  variant="primary" 
                  type="submit" 
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update Vendor"}
                </Button>
                <Button 
                  variant="secondary" 
                  onClick={() => navigate('/vendors/list')}
                  disabled={loading}
                >
                  Cancel
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default EditVendor;